import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './api';

// The vendor-app side of the MCP OAuth consent handoff (docs/MCP_SERVER_PLAN.md D9).
// baseUrl already ends in /api, so paths are relative to that.

export interface McpPendingConsent {
  clientName: string;
  scopes: string[];
}

export interface McpCompleteRequest {
  requestId: string;
  idToken: string;
  approve: boolean;
}

export interface McpCompleteResponse {
  redirectUrl: string;
}

export const mcpOAuthApi = createApi({
  reducerPath: 'mcpOAuthApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getMcpPendingConsent: builder.query<McpPendingConsent, string>({
      query: (requestId) => `/mcp-oauth/pending/${requestId}`,
    }),
    completeMcpConsent: builder.mutation<McpCompleteResponse, McpCompleteRequest>({
      query: (body) => ({ url: '/mcp-oauth/complete', method: 'POST', body }),
    }),
  }),
});

export const { useGetMcpPendingConsentQuery, useCompleteMcpConsentMutation } = mcpOAuthApi;
